import { render, staticRenderFns } from "./termsandConditions.vue?vue&type=template&id=672e31aa&"
import script from "./termsandConditions.vue?vue&type=script&lang=js&"
export * from "./termsandConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports